import { render, staticRenderFns } from "./CommandsCard.vue?vue&type=template&id=6c7346d5&scoped=true&"
import script from "./CommandsCard.vue?vue&type=script&lang=ts&"
export * from "./CommandsCard.vue?vue&type=script&lang=ts&"
import style0 from "./CommandsCard.vue?vue&type=style&index=0&id=6c7346d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7346d5",
  null
  
)

export default component.exports